import { ResponseMergerHandler } from '../../../cache-logic-interface';

// do not cache the requests
export let customNanoRequestQueryMerger: ResponseMergerHandler = function () {};
